import { Component, Prop, h } from '@stencil/core';
import { getConstant } from '../../../../../utils/constants-helpers';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';

/**
 * Call-to-action type 11 component for SignNow brand user engagement
 *
 * @product signnow
 * @version 1.0.1
 * @category cta
 * @contentConfig Call-to-action component for encouraging user engagement and sign-ups
 * @constant CTA_TYPE_11_HEADING - "be ready to get more" - Main heading for CTA section
 * @constant CTA_TYPE_11_DESCRIPTION - "Join over 28 million airSlate SignNow users" - Description text
 * @constant CTA_TYPE_11_BUTTON_TEXT - "Start your free trial" - Primary action button text in sign-up form
 * @constant CTA_TYPE_11_FORM_NOTE - "No credit card required" - Form note text
 * @slot heading - {required}, <me-heading variant="2"> - Main CTA heading
 * @slot description - <me-text> - CTA description text
 * @slot action-primary - {required} - Primary action form or button
 */
@Component({
  tag: 'sn-call-to-action-type-11',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNCallToActionType11 {
  /**
   * Component constants object containing all required text constants
   */
  @Prop({ mutable: true }) constants?: Record<string, string> | string;

  /**
   * HTML tag for the heading element (h1, h2, h3, h4, h5, h6)
   * @default "h2"
   */
  @Prop() headingTag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h2';

  componentWillLoad() {
    this.constants = parseJsonProp(this.constants);
  }

  render() {
    return (
      <call-to-action-type-11>
        <me-text slot="heading" class="me-text--label">
          {getConstant(this.constants, 'CTA_TYPE_11_DESCRIPTION', 'be ready to get more')}
        </me-text>
        <me-heading slot="description" variant="2" tag={this.headingTag}>
          {getConstant(this.constants, 'CTA_TYPE_11_HEADING', 'Join over 28 million airSlate SignNow users')}
        </me-heading>
        <form-free-trial-type-1
          slot="action-primary"
          button-variant="primary"
          mobile-layout="stacked"
          note={getConstant(this.constants, 'CTA_TYPE_11_FORM_NOTE', 'No credit card required')}
          submitText={getConstant(this.constants, 'CTA_TYPE_11_BUTTON_TEXT', 'Start your free trial')}
        ></form-free-trial-type-1>
      </call-to-action-type-11>
    );
  }
}
